module.exports = __webpack_public_path__ + "static/img/webapps-03.11f1f17f.jpg";